import React,{Component} from 'react'
import { BrowserRouter as Router, Route, Switch,Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import IndexRouter from './router/index';
import Home from './pages/home'
import Register from './pages/register'
import store from "./store";
import "braft-editor/dist/index.css";
// import './mock'

class App extends Component{
  // componentDidCatch(err,info){
  //   location.href='/error'
  // }
  render(){
    const load = sessionStorage.getItem("load");
    return (
      <Provider store={store}>
        <Router>
            {
               load == "1" ?
                  <IndexRouter />
                :
                <Switch>
                  <Route path="/" component={Register} exact />
                  <Redirect to={{ pathname: '/' }} />
              </Switch>
            }
        </Router>
      </Provider>
    );
  }
}

export default App;
